<!-- @format -->
<template>
    <div class="widget email-template-widget">
        <div class="widget-header">
            <h3>{{ steps[step].title }}</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <div v-if="step === 'create'" class="create-step">
                <email-template-composer
                    ref="composer"
                    :email-template-id="emailTemplateId"
                    :account-id="accountId"
                    :client-id="clientId"
                    :agency-id="agencyId"
                />
            </div>
            <div v-else-if="step === 'saving'" class="saving-step">
                <loading-screen-svg />
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button
                    class="secondary-btn"
                    :loading="steps[step].loading"
                    @click="openEmailTestWidget"
                    >Send test email</app-button
                >
                <app-button :loading="steps[step].loading" @click="steps[step].action">
                    {{ steps[step].buttonText }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const EmailTemplateComposer = () => import('@/components/one-to-one-email/email-template-composer');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'email-template-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'email-template-composer': EmailTemplateComposer,
        'loading-screen-svg': LoadingScreenSvg,
    },

    props: ['options', 'widget'],

    data() {
        return {
            isInitializing: true,
            emailTemplateId: this.options.emailTemplateId,
            accountId: this.options.accountId,
            agencyId: this.options.agencyId,
            clientId: this.options.clientId,
            step: 'create',
            steps: {
                create: {
                    title: 'Email Template',
                    buttonText: 'Save',
                    action: this.saveAndGoBack,
                    loading: false,
                },

                saving: {
                    title: 'Saving',
                    buttonText: 'Saving',
                    action: () => {},
                    loading: true,
                },
            },
        };
    },

    methods: {
        openEmailTestWidget() {
            this.saveTemplate()
                .then((template) => {
                    this.emailTemplateId = template.id;

                    EventBus.$emit('open-widget', {
                        name: 'email-test-widget',
                        emailTemplateId: this.emailTemplateId,
                    });
                })
                .finally(() => {
                    this.step = 'create';
                });
        },

        saveAndGoBack() {
            this.saveTemplate()
                .then(() => {
                    this.$helpers.showSuccessNotification('Template successfully saved.');

                    this.closeWidget();
                })
                .catch((error) => {
                    this.step = 'create';

                    this.$helpers.showFailNotification('Failed to save template.', { error });
                });
        },

        saveTemplate() {
            var isValid = this.$refs.composer.isValid();

            if (isValid) {
                this.step = 'saving';
                this.$refs.composer.hideErrors();

                return this.$refs.composer.save();
            } else {
                this.$refs.composer.showErrors();
            }
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style scoped>
.email-template-widget .saving-step {
    text-align: center;
}

.email-template-widget .content-wrapper {
    padding: 0;
}

.email-template-widget .action-container {
    display: flex;
}

.email-template-widget .action-container .btn {
    margin-left: 15px;
}

.email-template-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877d88;
}

.email-template-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}

.email-template-widget .action-container .btn.white-btn {
    background: #ffffff;
    color: #877d88;
    border: 2px solid #e9e9ef;
}

.email-template-widget .action-container .secondary-btn {
    background: transparent;
    color: #877d88;
    border: 2px solid #877d88;
}

.email-template-widget .action-container .secondary-btn:hover {
    background: #e1e0e5;
}
</style>
